/**
 * Web Vitals ölçümlerini raporlama fonksiyonu
 * Google Analytics'e Web Vitals metriklerini gönderir
 * 
 * @param {Function} onPerfEntry - Performans ölçümlerini işleyecek callback fonksiyonu
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Core Web Vitals ölçümleri
      getCLS(onPerfEntry); // Cumulative Layout Shift
      getFID(onPerfEntry); // First Input Delay
      getFCP(onPerfEntry); // First Contentful Paint
      getLCP(onPerfEntry); // Largest Contentful Paint
      getTTFB(onPerfEntry); // Time to First Byte
    });
  }
};

// Google Analytics'e Web Vitals metriklerini gönderme örneği
// index.js dosyasında şu şekilde kullanılabilir:
// 
// reportWebVitals(({ name, delta, id }) => {
//   if (window.gtag) {
//     window.gtag('event', name, {
//       event_category: 'Web Vitals',
//       event_label: id,
//       value: Math.round(name === 'CLS' ? delta * 1000 : delta),
//       non_interaction: true,
//     });
//   }
// });

export default reportWebVitals;
